module.exports = __webpack_public_path__ + "img/19_51.c325dc2b.png";